
/*!
Backbone WrapperNext - v1.1.3
*/

!function(e, t) {
    "function" == typeof define && define.amd && define('wrappernext',[ "underscore", "exports", "backbone", "moment" ], function(s, r, n, i) {
        e.WrapperNext = t(e, r, s, n, i);
    });
}(this, function(e, t, s, r, n) {
    t.VERSION = "1.1.3";
    var i = t.Collection = r.Collection.extend({
        keyWordFilter: function(e, t) {
            e = e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
            var r = new RegExp(e, "i"), n = s.filter(this.models, function(e) {
                for (var s = 0; s < t.length; s++) if (r.test(e.get(t[s]))) return !0;
                return !1;
            }), i = this.clone();
            return i.reset(n), i;
        },
        sort: function(e, t) {
            var s = this.sortBy(function(e) {
                return parseInt(e.cid.substring(1));
            });
            if (this.reset(s, {
                silent: !0
            }), t !== h.sortDefault) {
                var r = this.sortBy(function(s) {
                    var r = null;
                    switch (t) {
                      case h.sortDate:
                      case h.sortDateDec:
                        r = -parseInt(n(s.get(e), "DD/MM/YYYY").format("YYYYMMDD"));
                        break;

                      case h.sortInt:
                      case h.sortIntDec:
                        r = -parseInt(s.get(e));
                        break;

                      case h.sortString:
                      case h.sortStringDec:
                        r = s.get(e);
                    }
                    return r;
                });
                (t === h.sortDateDec || t === h.sortIntDec || t === h.sortStringDec) && (r = r.reverse()), 
                this.reset(r, {
                    silent: !0
                });
            }
        },
        group: function(e) {
            var t = new Array(), s = this.groupBy(function(t) {
                for (var s = "", r = 0; r < e.length; r++) s += t.get(e[r]);
                return s;
            });
            for (var r in s) {
                var n = this.clone();
                n.reset(s[r]), t.push(n);
            }
            return t;
        }
    });
    t.CollectionAjax = i.extend({
        constructor: function(e, t) {
            var n = this;
            this.opts = t || {}, this.arrayCodeErreurTech = [], this.arrayCodeSessionLost = [ -31, "-31", -30, "-30" ], 
            this.arrayCodeNbMaxConnexion = [ -100, "-100" ], this.businessMessage = null, this.about = new c(), 
            s.bindAll(this, "parse"), this.parse = s.wrap(this.parse, function(e, t) {
                var s = n.preparse(t);
                if (!n.businessMessage.isSuccess()) return {};
                var r = e(s);
                return r;
            }), r.Collection.prototype.constructor.call(this, e);
        },
        preparse: function(e) {
            var t = {};
            if (this.businessMessage = new a(e, {
                parse: !0
            }), this.businessMessage.setArrayCodeErreurTech(this.arrayCodeErreurTech), this.businessMessage.setArrayCodeSessionLost(this.arrayCodeSessionLost), 
            this.businessMessage.setArrayCodeNbMaxConnexion(this.arrayCodeNbMaxConnexion), this.opts.isNoIntermediate) t = e.data; else for (var s in e.data) t = e.data[s];
            return t;
        },
        fetchNext: function(e, t) {
            var s = {
                type: e.type || "GET",
                contentType: "application/json",
                success: function(s) {
                    return s.businessMessage.isDeconnecte() ? window.location.reload() : (s.businessMessage.isNbMaxConnexion() && window.location.replace(s.businessMessage.get("urlRedirection")), 
                    s.businessMessage.isSuccess() ? t[e.successCallback] && t[e.successCallback](s) : s.businessMessage.isErrorTech() ? t[e.errorTechCallback] && t[e.errorTechCallback](s.businessMessage, s.about) : t[e.errorFoncCallback] && t[e.errorFoncCallback](s.businessMessage, s.about), 
                    void 0);
                },
                error: function(s) {
                    t[e.errorTechCallback] && t[e.errorTechCallback](void 0, s.about);
                }
            };
            "POST" === e.type && (s.data = JSON.stringify(e.data || {})), this.fetch(s);
        },
        setArrayCodeErreurTech: function(e) {
            s.isArray(e) && (this.arrayCodeErreurTech = e);
        },
        setArrayCodeSessionLost: function(e) {
            s.isArray(e) && (this.arrayCodeSessionLost = e);
        },
        setArrayCodeNbMaxConnexion: function(e) {
            s.isArray(e) && (this.arrayCodeNbMaxConnexion = e);
        },
        setOptions: function(e) {
            e || (e = {});
            for (var t in e) this.opts[t] = e[t];
        },
        setAbout: function(e) {
            e || (e = {}), this.about.set(e);
        },
        getAbout: function() {
            return this.about.get(options);
        }
    });
    var o = t.Model = r.Model.extend({});
    t.I18n = r.Model.extend({
        parse: function(e) {
            var t = function(e) {
                return s(e).inject(function(e, t, r) {
                    var n = e, i = r.split("."), o = i.length - 1;
                    return s(i).each(function(e, s) {
                        n = n[e] = s == o ? t : n[e] || {};
                    }), e;
                }, {});
            };
            return t(e);
        },
        fetchI18n: function(e) {
            var t = {
                type: "GET",
                contentType: "application/json",
                success: function(t) {
                    e.callback && e.callback(t);
                },
                error: function(t) {
                    t.attributes = t.parse(t.defaults), e.callback && e.callback(t);
                }
            };
            "boolean" != typeof e.isI18nEnabled && (e.isI18nEnabled = !0), e.isI18nEnabled ? this.fetch(t) : t.error(this);
        }
    }), t.ModelZP = r.Model.extend({
        fetchFlat: function(e, t) {
            var s = {
                type: "GET",
                contentType: "application/json",
                success: function(s) {
                    t[e.successCallback] && t[e.successCallback](s);
                },
                error: function(s) {
                    t[e.errorCallback] && t[e.errorCallback](s);
                }
            };
            this.fetch(s);
        }
    });
    var a = t.BusinessMessage = r.Model.extend({
        arrayCodeErreurTech: null,
        defaults: {
            codeRetour: "",
            message: "",
            service: "",
            urlRedirection: "",
            data: null
        },
        parse: function(e) {
            var t = {};
            return t.codeRetour = e.codeRetour, t.message = e.message, t.service = e.service, 
            t.urlRedirection = e.urlRedirection, 0 !== e.codeRetour && "0" !== e.codeRetour && (t.data = e.data), 
            t;
        },
        isSuccess: function() {
            var e = !1;
            return ("0" === this.get("codeRetour") || 0 === this.get("codeRetour")) && (e = !0), 
            e;
        },
        isErrorTech: function() {
            return s.isArray(this.arrayCodeErreurTech) ? s.contains(this.arrayCodeErreurTech, this.get("codeRetour")) : !1;
        },
        isDeconnecte: function() {
            return s.isArray(this.arrayCodeSessionLost) ? s.contains(this.arrayCodeSessionLost, this.get("codeRetour")) : !1;
        },
        isNbMaxConnexion: function() {
            return s.isArray(this.arrayCodeNbMaxConnexion) ? s.contains(this.arrayCodeNbMaxConnexion, this.get("codeRetour")) : !1;
        },
        setArrayCodeErreurTech: function(e) {
            s.isArray(e) && (this.arrayCodeErreurTech = e);
        },
        setArrayCodeSessionLost: function(e) {
            s.isArray(e) && (this.arrayCodeSessionLost = e);
        },
        setArrayCodeNbMaxConnexion: function(e) {
            s.isArray(e) && (this.arrayCodeNbMaxConnexion = e);
        }
    }), c = t.AboutAjax = r.Model.extend({
        defaults: {
            actionName: "",
            actionTag: "",
            stepName: "",
            steptag: ""
        }
    });
    t.ModelAjax = o.extend({
        constructor: function(e, t) {
            var n = this;
            this.opts = t || {}, this.arrayCodeErreurTech = [], this.arrayCodeSessionLost = [ -31, "-31", -30, "-30" ], 
            this.arrayCodeNbMaxConnexion = [ -100, "-100" ], this.businessMessage = null, this.about = new c(), 
            s.bindAll(this, "parse"), this.parse = s.wrap(this.parse, function(e, t) {
                var s = n.preparse(t);
                if (!n.businessMessage.isSuccess()) return {};
                var r = e(s), i = n.postParse(r);
                return i;
            }), r.Model.prototype.constructor.call(this, e);
        },
        preparse: function(e) {
            var t = {};
            if (this.businessMessage = new a(e, {
                parse: !0
            }), this.businessMessage.setArrayCodeErreurTech(this.arrayCodeErreurTech), this.businessMessage.setArrayCodeSessionLost(this.arrayCodeSessionLost), 
            this.businessMessage.setArrayCodeNbMaxConnexion(this.arrayCodeNbMaxConnexion), this.opts.isNoIntermediate) t = e.data; else for (var s in e.data) t = e.data[s];
            return t;
        },
        postParse: function(e) {
            return e;
        },
        fetchNext: function(e, t) {
            var s = {
                type: e.type || "GET",
                contentType: "application/json",
                success: function(s) {
                    return s.businessMessage.isDeconnecte() ? window.location.reload() : (s.businessMessage.isNbMaxConnexion() && window.location.replace(s.businessMessage.get("urlRedirection")), 
                    s.businessMessage.isSuccess() ? t[e.successCallback] && t[e.successCallback](s) : s.businessMessage.isErrorTech() ? t[e.errorTechCallback] && t[e.errorTechCallback](s.businessMessage, s.about) : t[e.errorFoncCallback] && t[e.errorFoncCallback](s.businessMessage, s.about), 
                    void 0);
                },
                error: function(s) {
                    t[e.errorTechCallback] && t[e.errorTechCallback](void 0, s.about);
                }
            };
            "POST" === e.type && (s.data = JSON.stringify(e.data || {})), this.fetch(s);
        },
        setArrayCodeErreurTech: function(e) {
            s.isArray(e) && (this.arrayCodeErreurTech = e);
        },
        setArrayCodeSessionLost: function(e) {
            s.isArray(e) && (this.arrayCodeSessionLost = e);
        },
        setArrayCodeNbMaxConnexion: function(e) {
            s.isArray(e) && (this.arrayCodeNbMaxConnexion = e);
        },
        setOptions: function(e) {
            e || (e = {});
            for (var t in e) this.opts[t] = e[t];
        },
        setAbout: function(e) {
            e || (e = {}), this.about.set(e);
        },
        getAbout: function() {
            return this.about.get(options);
        }
    });
    var u = t.View = r.View.extend({
        constructor: function(e) {
            this.statesView = new o(), r.View.prototype.constructor.call(this, e);
        },
        remove: function() {
            if (this.$el.remove(), this.stopListening(), this.views) for (var e in this.views) {
                var t = this.views[e];
                t instanceof r.View && t.remove();
            }
            return this;
        },
        empty: function() {
            if (this.$el.empty(), this.stopListening(), this.undelegateEvents(), this.views) for (var e in this.views) {
                var t = this.views[e];
                t instanceof r.View && t.remove();
            }
            return this;
        },
        set: function(e, t, s) {
            return this.statesView.set(e, t, s), this;
        },
        get: function(e) {
            return this.statesView.get(e);
        }
    });
    t.ItemView = u.extend({}), t.ListView = u.extend({
        constructor: function(e) {
            this.itemViewArray = new Array(), this.$elList = this.$el, t.View.prototype.constructor.call(this, e);
        },
        renderList: function(e) {
            var t = this.$elList;
            this.removeOldItemView();
            for (var s = 0; s < e.length; s++) {
                var r = this.renderItem(e.models[s], s);
                null !== r && (this.itemViewArray.push(r), t.append(r.$el));
            }
            this.postRender();
        },
        renderItem: function() {},
        postRender: function() {},
        removeOldItemView: function() {
            for (var e = 0; e < this.itemViewArray.length; e++) this.stopListening(this.itemViewArray[e]), 
            this.itemViewArray[e].remove();
            this.itemViewArray = new Array();
        },
        remove: function() {
            u.prototype.remove.call(this), this.removeOldItemView();
        },
        empty: function() {
            u.prototype.empty.call(this), this.removeOldItemView();
        }
    }), t.Dispatcher = r.View.extend({
        constructor: function(e) {
            this.statesDispatcher = new o(), this.models = {}, this.collections = {}, this.views = {}, 
            r.View.prototype.constructor.call(this, e);
        },
        set: function(e, t, s) {
            return this.statesDispatcher.set(e, t, s), this;
        },
        get: function(e) {
            return this.statesDispatcher.get(e);
        }
    }), t.UrlRedirection = function(e, t) {
        var e = e, t = t || {};
        this.redirect = function(s, r, n) {
            r || (r = {}), n || (n = {});
            var i = e + s + "?";
            for (var o in r) i += o + "=" + r[o] + "&";
            for (var o in t) i += o + "=" + t[o] + "&";
            var a = i[i.length - 1];
            ("?" === a || "&" === a) && (i = i.substring(0, i.length - 1)), n.ancre && (i += "#" + n.ancre), 
            n.isEditerRib && (i = i.replace("iban=", "contractId=")), n.newTab ? window.open(i) : window.location = i;
        }, this.setParams = function(e) {
            e || (e = {});
            for (var s in e) t[s] = e[s];
        };
    }, t.queryString = function() {
        var e = {}, t = window.location.search.substring(1);
        if ("" === t) return e;
        for (var s = t.split("&"), r = 0; r < s.length; r++) {
            var n = s[r].split("=");
            e[n[0]] = n[1];
        }
        return e;
    };
    var h = t.constantes = {
        sortDefault: 0,
        sortDate: 1,
        sortInt: 2,
        sortString: 3,
        sortDateDec: 4,
        sortIntDec: 5,
        sortStringDec: 6
    };
    return t;
});